import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { Idioma, IDIOMAS, LanguageService } from 'app/core/i18n/language.service';
import { UserService } from 'app/core/user/user.service';

/**
 * Selector de idioma ES / EN.
 *
 * - `conSesion = false` (login, registro, paginas publicas): cambia al momento y
 *   deja la eleccion pendiente para subirla al perfil al iniciar sesion.
 * - `conSesion = true` (menu de usuario): guarda en el perfil y recarga.
 */
@Component({
    selector: 'language-toggle',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatButtonModule, MatIconModule, MatMenuModule],
    template: `
        <button mat-button type="button" [matMenuTriggerFor]="menu" class="language-toggle" [class.language-toggle--flotante]="!conSesion" aria-label="Idioma / Language">
            <mat-icon [svgIcon]="'heroicons_outline:language'" class="icon-size-5"></mat-icon>
            <span class="ml-1 font-medium uppercase">{{ language.actual() }}</span>
        </button>
        <mat-menu #menu="matMenu" [xPosition]="'before'">
            @for (i of idiomas; track i.id) {
                <button mat-menu-item type="button" (click)="elegir(i.id)">
                    <span [class.font-semibold]="i.id === language.actual()">{{ i.label }}</span>
                </button>
            }
        </mat-menu>
    `,
    // Sin sesion flota sobre pantallas con fondo de color (el panel azul del
    // login): necesita fondo propio para leerse.
    styles: [`
        .language-toggle--flotante {
            background: var(--o-bg-fff, #fff) !important;
            color: var(--o-tx-1e293b, #1e293b) !important;
            border: 1px solid rgba(15, 23, 42, 0.12);
            box-shadow: 0 1px 3px rgba(15, 23, 42, 0.15);
        }
        .language-toggle--flotante .mat-icon { color: #475569 !important; }
    `],
})
export class LanguageToggleComponent {
    @Input() conSesion = false;

    readonly language = inject(LanguageService);
    private _userService = inject(UserService);
    readonly idiomas = IDIOMAS;

    elegir(idioma: Idioma): void {
        if (idioma === this.language.actual()) return;
        if (this.conSesion) {
            this._userService.cambiarIdioma(idioma);
        } else {
            this.language.usar(idioma, { sinSesion: true });
        }
    }
}
